import React from 'react';
import { Nav } from '../components/Nav.tsx';
import { Footer } from '../components/Footer.tsx';
import { AIStorefrontFeatures } from '../components/AIStorefrontFeatures.tsx';
import { AIStorefrontDelight } from '../components/AIStorefrontDelight.tsx';
import { AIStorefrontMore } from '../components/AIStorefrontMore.tsx';
import { AIStorefrontVoice } from '../components/AIStorefrontVoice.tsx';
import { AIStorefrontAgents } from '../components/AIStorefrontAgents.tsx';
import { AIStorefrontMore2 } from '../components/AIStorefrontMore2.tsx';
import { AIStorefrontVoice2 } from '../components/AIStorefrontVoice2.tsx';
import { AIStorefrontFAQ } from '../components/AIStorefrontFAQ.tsx';
const LOGOS = [{
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-1-7uox6tm8dl3.png',
  alt: 'Brand 1'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-2-tz2mhq4dv1.png',
  alt: 'Brand 2'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-3-lh6i2tsuqjr.png',
  alt: 'Brand 3'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-4-qh95xz1yxuc.png',
  alt: 'Brand 4'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-5-fe93nfq7rdn.png',
  alt: 'Brand 5'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-6-bnjr6o8mjvl.png',
  alt: 'Brand 6'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-7-y8t5opowp.png',
  alt: 'Brand 7'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-8-kvdzezq2byc.png',
  alt: 'Brand 8'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-9-4e8beemjuv3.png',
  alt: 'Brand 9'
}];
export const AIStorefront = () => {
  return <main>
      <Nav />

      {/* ── Section 1: Hero ── */}
      <section data-name="AI Storefront Hero" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6'
    }}>
        <div data-name="Hero Content" className="aistorefront-hero-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '180px',
        paddingBottom: '80px'
      }}>

          {/* ── Eyebrow ── */}
          <div data-name="Eyebrow" className="animate-fade-slide-up" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '32px'
        }}>
            {/* 10 px square decoration */}
            <div aria-hidden="true" style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#091717',
            flexShrink: 0
          }} />
            <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 500,
            fontSize: '14px',
            letterSpacing: '0.04em',
            textTransform: 'uppercase' as const,
            color: '#091717'
          }}>
              AI Storefront
            </span>
          </div>

          {/* ── Headline + Description two-column ── */}
          <div data-name="Headline Block" className="aistorefront-headline-block animate-fade-slide-up-delay-1" style={{
          display: 'flex',
          flexDirection: 'row' as const,
          gap: '64px',
          alignItems: 'flex-end'
        }}>
            {/* Left: headline */}
            <div data-name="Headline" className="aistorefront-headline" style={{
            flex: '0 0 68%'
          }}>
              <h1 className="aistorefront-h1" style={{
              margin: 0,
              lineHeight: 1.05,
              color: '#091717',
              fontSize: 'clamp(56px, 8.8vw, 120px)'
            }}>
                {/* "Power" — Instrument Serif italic */}
                <span style={{
                fontFamily: 'Instrument Serif, serif',
                fontStyle: 'italic',
                fontWeight: 400,
                letterSpacing: '-0.02em',
                display: 'inline'
              }}>
                  Power
                </span>
                {/* "your store" — Instrument Sans */}
                <span style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontStyle: 'normal',
                fontWeight: 400,
                display: 'inline'
              }}>
                  {' '}your store
                </span>
              </h1>
            </div>

            {/* Right: description — pinned to the right edge of the container */}
            <div data-name="Description" className="aistorefront-description" style={{
            marginLeft: 'auto',
            flexShrink: 0,
            paddingBottom: '6px'
          }}>
              <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: 'clamp(16px, 1.5vw, 20px)',
              lineHeight: 1.4,
              color: '#091717',
              margin: 0
            }}>
                Bring AI to every part of your store.
                <br className="hidden lg:block" />
                {' '}Build it in minutes. Stay on-brand.
                <br className="hidden lg:block" />
                {' '}Let it sell itself.
              </p>
            </div>
          </div>

          {/* ── Hero image ── */}
          <div data-name="Hero Image" className="animate-fade-slide-up-delay-2" style={{
          marginTop: '24px'
        }}>
            <picture>
              <source 
                media="(max-width: 767px)" 
                srcSet="https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/hero-asset-mobile-04vaavit16vx.png" 
              />
              <img 
                alt="Orella Home Assistant Storefront Interface" 
                data-name="Storefront Showcase Screenshot" 
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block'
                }} 
                src="https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/hero-asset-2-l05qt59gijl.png" 
              />
            </picture>
          </div>

        </div>
      </section>

      {/* ── Section 2: Trusted logo bar ── */}
      <section data-name="Logo Bar" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6'
    }}>

        {/* Label */}
        <div className="section-content" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingBottom: '16px',
        textAlign: 'center'
      }}>
          <p style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 500,
          fontSize: 'clamp(16px, 1.2vw, 20px)',
          color: '#091717',
          margin: 0
        }}>
            Trusted by brands that care about growth
          </p>
        </div>

        {/* Marquee — full width, outside constrained container */}
        <div data-name="Logo Marquee" aria-label="Trusted brands" style={{
        width: '100%',
        paddingBottom: '40px',
        overflow: 'hidden'
      }}>
          <div className="marquee-overflow" style={{
          width: '100%'
        }}>
            <div className="marquee-track">
              {LOGOS.map((logo, i) => <img key={`a-${i}`} src={logo.url} alt={logo.alt} className="h-[28px] md:h-[36px] lg:h-[50px] w-auto object-contain flex-shrink-0 mx-5 md:mx-10" style={{
              filter: 'brightness(0) saturate(100%) invert(6%) sepia(40%) saturate(700%) hue-rotate(140deg) brightness(92%) contrast(102%)'
            }} />)}
              {LOGOS.map((logo, i) => <img key={`b-${i}`} src={logo.url} alt="" aria-hidden="true" className="h-[28px] md:h-[36px] lg:h-[50px] w-auto object-contain flex-shrink-0 mx-5 md:mx-10" style={{
              filter: 'brightness(0) saturate(100%) invert(6%) sepia(40%) saturate(700%) hue-rotate(140deg) brightness(92%) contrast(102%)'
            }} />)}
            </div>
          </div>
        </div>

      </section>

      <AIStorefrontFeatures />

      <AIStorefrontDelight />

      <AIStorefrontMore />

      <AIStorefrontVoice />

      <AIStorefrontAgents />

      <AIStorefrontMore2 />

      <AIStorefrontVoice2 />

      <AIStorefrontFAQ />

      <Footer />
    </main>;
};